angular.module('unergie.main')
.factory('AuthService', ($q, $rootScope, $state, $uibModal, DataAccessReferences, ApiUser,
    BoFeaturesService, ReferencesService, SocketFactory, EventProcessorService) => {
    let logged = true
    let auth = {}
    let menus
    let submenus

    let modalOpen = false

    const openLoginModal = function () {
        if (!modalOpen) {
            modalOpen = true
            const modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                backdrop: 'static',
                backdropClass: 'login-form',
                controller: 'loginModalCtrl',
                templateUrl: '/states/loginModal/loginModal.html',
            })
            return modalInstance.closed.then(() => {
                modalOpen = false
            })
        }
    }

    const reset = function () {
        SocketFactory.disconnect()
        auth = {}
        logged = false
        menus = undefined
        submenus = undefined
    }

    const checkLogin = () => {
        return ApiUser.checkLogin().$promise
        .catch((error) => {
            if (error.status === 401) {
                reset()
                openLoginModal()
                return false
            }
            throw error
        })
    }

    const refreshMenus = () => {
        return checkLogin().then((check) => {
            if (check) {
                auth = check.toJSON()

                return BoFeaturesService.getFeatures().then((features) => {
                    menus = features.boMenus
                    submenus = _.map(_.flatten(_.map(menus, 'submenus')), 'state')

                    // WEB-SOCKETS
                    SocketFactory.join(auth.uuid, $rootScope)
                    SocketFactory.join(auth.groups, $rootScope)
                    SocketFactory.join(auth.organization, $rootScope)
                    SocketFactory.register('EVENT', EventProcessorService.processEvent)

                    return ReferencesService.getRef('id-prefixes')
                    .then((prefixes) => {
                        $rootScope.clientPrefix = prefixes.client
                        $rootScope.contractElecPrefix = prefixes.elec
                        $rootScope.contractGasPrefix = prefixes.gas
                        $rootScope.placePrefix = prefixes.place
                    })
                })
                .then(() => check)
            }
            return check
        }).catch((error) => error)
    }

    const isLogged = () => logged

    const logout = function () {
        reset()
        return openLoginModal()
    }

    const getMenus = () => menus

    const getSubMenus = () => submenus

    const isMenuAccessible = (menu) => {
        const names = _.isArray(menu) ? menu : [menu]
        return _.some(submenus, (s) => names.includes(s))
    }

    const getAuth = () => auth

    const getUser = function () {
        return (auth.user) ? `${auth.user} @ ${auth.organization} (${auth.groups})` : ''
    }

    const userHasGroup = function (group) {
        if (auth.groups !== undefined) {
            const groups = auth.groups.split(',')
            if (angular.isArray(group)) {
                let hasGroup = false
                group.forEach((g) => {
                    if (groups.indexOf(g) !== -1) {
                        hasGroup = true
                    }
                })
                return hasGroup
            }
            return groups.indexOf(group) !== -1
        }
        return false
    }

    const getOrg = function () {
        return auth.organization
    }

    return {
        isLogged,
        logout,
        getMenus,
        getSubMenus,
        refreshMenus,
        getUser,
        getAuth,
        openLoginModal,
        userHasGroup,
        isMenuAccessible,
        getOrg,
    }
})
